/**
 * Loading Toast Component
 * 
 * Shows a subtle loading toast message during initial URL sync to prevent flashing
 */

import React, { useEffect, useState } from 'react';
import '../styles/_loading-toast.scss';

const LoadingToast = ({ show, message = 'Loading...' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
    } else {
      // Fade out before hiding
      const timer = setTimeout(() => setIsVisible(false), 200);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!isVisible && !show) {
    return null;
  }

  return (
    <div className={`loading-toast ${isVisible && show ? 'visible' : ''}`}>
      <div className="loading-toast-content">
        <div className="loading-toast-spinner"></div>
        <span className="loading-toast-message">{message}</span>
      </div>
    </div>
  );
};

export default LoadingToast;

